import Vue from "vue";
import VueRouter from "vue-router";
import { Datetime } from 'vue-datetime';
import { router } from "./support/router";
Vue.use(Datetime);
Vue.use(VueRouter);
var app = new Vue({
    router: router
});
app.$mount('#app');
